"use strict";

var _interopRequireDefault = require("/build-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _defineProperty2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _jsencrypt = require("@/utils/jsencrypt");
var _whiteList = _interopRequireDefault(require("@services/whiteList"));
var _login2 = _interopRequireDefault(require("@/services/modules/login"));
var _store = _interopRequireDefault(require("@/store"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 获取验证码接口
var _default = exports.default = {
  name: 'Login',
  data: function data() {
    return {
      codeVisible: false,
      codeUrl: '',
      cookiePassword: '',
      loginForm: {
        username: '',
        password: '',
        // 123456
        rememberMe: false,
        uuid: '',
        pid: 1
      },
      loginRules: {
        username: [{
          required: true,
          trigger: 'blur',
          message: this.$t('userNameNotEmpty')
        }],
        password: [{
          required: true,
          trigger: 'blur',
          message: this.$t('passwordNotEmpty')
        }]
        // 二次修改  验证码的验证逻辑
        // code: [{ required: true, trigger: "change", message: "验证码不能为空" }]
      },
      loading: false,
      redirect: undefined,
      qrcode: null,
      code: undefined,
      secret: undefined,
      codeNum: 1
    };
  },
  watch: {
    $route: {
      handler: function handler(route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true
    }
  },
  created: function created() {
    // 二次修改 accessRoutes
    // this.getCode();
    this.loginForm.pid = process.env.VUE_APP_PID;
    this.getCookie();
  },
  methods: {
    handleClose: function handleClose() {
      this.codeNum = 1;
      this.code = '';
      this.qrcode = '';
      this.codeVisible = false;
    },
    getCode: function getCode() {
      // getCodeImg().then(res => {
      //   this.codeUrl = "data:image/gif;base64," + res.img;
      //   this.loginForm.uuid = res.uuid;
      // });
    },
    getCookie: function getCookie() {
      var username = _jsCookie.default.get('username');
      var password = _jsCookie.default.get('password');
      var rememberMe = _jsCookie.default.get('rememberMe');
      this.loginForm.username = username === undefined ? this.loginForm.username : username;
      this.loginForm.password = password === undefined ? this.loginForm.password : (0, _jsencrypt.decrypt)(password);
      this.loginForm.rememberMe = rememberMe === undefined ? false : Boolean(rememberMe);
    },
    handleLogin: function handleLogin() {
      var _this = this;
      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          _this.loading = true;
          if (_this.loginForm.rememberMe) {
            _jsCookie.default.set('username', _this.loginForm.username, {
              expires: 30
            });
            _jsCookie.default.set('password', (0, _jsencrypt.encrypt)(_this.loginForm.password), {
              expires: 30
            });
            _jsCookie.default.set('rememberMe', _this.loginForm.rememberMe, {
              expires: 30
            });
          } else {
            _jsCookie.default.remove('username');
            _jsCookie.default.remove('password');
            _jsCookie.default.remove('rememberMe');
          }
          _this.login();
        }
      });
    },
    login: function () {
      var _login = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var obj, res, roleLimit, roleReal, _data, _yield$this$$store$di, data, _data2;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              obj = _objectSpread({}, this.loginForm);
              if (this.code) {
                obj.code = this.code;
                obj.secret = this.secret;
              }
              if (obj.code === '') {
                delete obj.code;
              }
              _context.next = 6;
              return this.$store.dispatch('Login', obj);
            case 6:
              res = _context.sent;
              this.loading = false;
              if (!(res.code === 407)) {
                _context.next = 13;
                break;
              }
              this.qrcode = res.data.qr_code;
              this.secret = res.data.secret;
              this.codeVisible = true;
              return _context.abrupt("return");
            case 13:
              if (!(res.code === 402)) {
                _context.next = 22;
                break;
              }
              if (!(this.codeNum === 1)) {
                _context.next = 19;
                break;
              }
              this.code = '';
              this.codeVisible = true;
              this.codeNum = 2;
              return _context.abrupt("return");
            case 19:
              if (!(this.codeNum === 2)) {
                _context.next = 22;
                break;
              }
              this.$message.error(res.msg);
              return _context.abrupt("return");
            case 22:
              if (res.code) {
                _context.next = 39;
                break;
              }
              roleLimit = false;
              roleReal = res.data.auth_group_list;
              if (roleReal.length) {
                roleReal.map(function (item) {
                  if (item.status === '0') {
                    roleLimit = true;
                    return;
                  }
                });
              }
              if (!(!roleReal.length || roleLimit)) {
                _context.next = 31;
                break;
              }
              this.$message.error(this.$t('roleStatusIsDisablePleaseContractAdmin'));
              _data = {
                login_username: localStorage.getItem('name'),
                msg: this.$t('roleStatusIsDisablePleaseContractAdmin'),
                site_url: window.location.host
              };
              this.getLoginLog(_data);
              return _context.abrupt("return");
            case 31:
              _context.next = 33;
              return this.$store.dispatch('GetSiteAdmin');
            case 33:
              _yield$this$$store$di = _context.sent;
              data = _yield$this$$store$di.data;
              if (data.site_url) {
                this.getWhite();
              }
              // 本地测试用
              if (window.location.hostname === 'localhost') {
                this.getWhite();
              }
              _context.next = 41;
              break;
            case 39:
              this.loading = false;
              this.$message.error(res.msg || this.$t('loginFailed'));
            case 41:
              _context.next = 49;
              break;
            case 43:
              _context.prev = 43;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);
              // this.$message.error('账号密码错误')
              this.$message.error(_context.t0.msg);
              _data2 = {
                login_username: localStorage.getItem('name'),
                msg: _context.t0.msg,
                site_url: window.location.host
              };
              this.getLoginLog(_data2);
            case 49:
              this.loading = false;
            case 50:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 43]]);
      }));
      function login() {
        return _login.apply(this, arguments);
      }
      return login;
    }(),
    // 白名单请求
    getWhite: function getWhite() {
      var _this2 = this;
      // 白名单请求
      _whiteList.default.ifWhite().then(function (res) {
        var code = res.code,
          msg = res.msg;
        if (code !== 200) {
          _store.default.dispatch('LogOut').then(function () {
            location.reload();
          });
          var _data3 = {
            login_username: localStorage.getItem('name'),
            msg: msg,
            site_url: window.location.host
          };
          _this2.loading = false;
          _this2.getLoginLog(_data3);
          return alert(msg);
          // return this.$message.error(msg)
        }
        // debugger
        _this2.jump();
        var data = {
          login_username: localStorage.getItem('name'),
          msg: _this2.$t('loginSuccess'),
          site_url: window.location.host
        };
        _this2.getLoginLog(data);
      });
    },
    // 登录日志
    getLoginLog: function () {
      var _getLoginLog = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(data) {
        var _yield$LoginService$l, code, msg;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _login2.default.loginLog(data);
            case 2:
              _yield$LoginService$l = _context2.sent;
              code = _yield$LoginService$l.code;
              msg = _yield$LoginService$l.msg;
              if (!(code !== 200)) {
                _context2.next = 7;
                break;
              }
              return _context2.abrupt("return", this.$message.error(msg));
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getLoginLog(_x) {
        return _getLoginLog.apply(this, arguments);
      }
      return getLoginLog;
    }(),
    jump: function () {
      var _jump = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this3 = this;
        var _yield$this$$store$di2, data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return this.$store.dispatch('GetInfo', this.loginForm);
            case 3:
              _yield$this$$store$di2 = _context3.sent;
              data = _yield$this$$store$di2.data;
              this.$message({
                message: this.$t('loginSuccess'),
                type: 'success',
                duration: 500
              });
              setTimeout(function () {
                var routerData = '';
                if (data.role_id === 0) {
                  routerData = _this3.$router.resolve({
                    path: _this3.redirect
                  });
                } else {
                  var url = '';
                  if (['/account'].includes(_this3.redirect)) {
                    url = '/';
                  } else {
                    url = _this3.redirect;
                  }
                  routerData = _this3.$router.resolve({
                    path: url || '/'
                  });
                }
                window.open(routerData.href, '_self');
              }, 501);
              _context3.next = 12;
              break;
            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3["catch"](0);
              console.log(_context3.t0);
            case 12:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 9]]);
      }));
      function jump() {
        return _jump.apply(this, arguments);
      }
      return jump;
    }()
  }
};